// extracted by mini-css-extract-plugin
module.exports = {"textarea":"components-textSubject-textarea-a032ee06"};